"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BatchNormalization", {
  enumerable: true,
  get: function () {
    return _BatchNormalization.default;
  }
});

var _BatchNormalization = _interopRequireDefault(require("./BatchNormalization"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }